import { Record, Map, List } from 'immutable';
import { IDictionary, ReadonlyRecord } from '@bimser/core';
import { DmData, DmDataFactoryFromJS, IDmData } from '@bimser/common';

interface IBaseClipboardPanelContent {}

export interface IClipboardPanelContent extends IBaseClipboardPanelContent {
	items?: IDictionary<Array<IDmData>>;
}

export interface IReadonlyClipboardPanelContent extends IBaseClipboardPanelContent {
	items?: Map<string, List<DmData>>;
}

export type ClipboardPanelContent = ReadonlyRecord<IReadonlyClipboardPanelContent>;

export const ClipboardPanelContentFactory = Record<IReadonlyClipboardPanelContent>({
	items: Map()
});

export const ClipboardPanelContentFactoryFromJS = function (data: IClipboardPanelContent) {
	const items = Object.keys(data.items).reduce(function (
		previous: IDictionary<List<DmData>>,
		current
	) {
		const currentItem: Array<DmData> = data.items[current].map(DmDataFactoryFromJS);
		previous[current] = List(currentItem);
		return previous;
	}, {});

	return ClipboardPanelContentFactory({
		...data,
		items: Map(items)
	});
};
